import React, { Fragment } from 'react'
import { Field, reduxForm } from 'redux-form'
// import { connect } from 'react-redux'

// Inquire Import
// import { validate, renderInput, renderTextArea  } from  './'
import { validate } from  '../helpers'
import {
  email,
  aol,
  required,
  phoneNumber,


} from './Validate'

let StepThree = props => {

  const { handleSubmit, previousPage, pristine, submitting } = props

  return (
    <Fragment>
      <section className="stepTwo">
       <div className="container">
          <aside className="sidebar">
            <h3>Project Details :</h3>
            <p>Please provide us with any details concering the nature of your project.</p>
          </aside>
         <article className="wizardform">
          <form onSubmit={handleSubmit}>
      
            <fieldset>
              <div className="form-group text-area">
                <label htmlFor="aboutProject">about the project</label>      
                 <Field 
                    name="aboutProject"
                    type="text"
                    component="textarea"
                    label="About Project"
                    validate={required}
                  />
              </div>
              <div className="form-group ">
                <label htmlFor="projectGoal">what are the project goals?</label>
                 <Field 
                    name="projectGoal"
                    type="text"
                    component="textarea"
                    label="Company Name"
                    validate={required}
                  />
              </div>
              <div className="button-group">
                <button className="btn previous" type="button" onClick={previousPage}>Previous</button>
                <button className="btn next" disabled={ pristine||submitting }type="submit">Submit</button>
              </div>
            </fieldset>
          </form>
        </article>
        </div>
      </section>
    </Fragment>
  )
}

export default reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(StepThree)



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/GettingStarted/components/StepThree.js